import type { Session } from '@supabase/supabase-js';

import {
  PaymentIncidentActionResponseSchema,
  PaymentIncidentListResponseSchema,
  type PaymentIncidentActionResponse,
  type PaymentIncidentListResponse,
} from '@nuberu/types';

import { apiFetch } from '@/lib/api';

// Client contract for the backoffice's payment incidents ("Pagos sin reserva"),
// Zod-parsed on arrival with the API's own schemas.

export const fetchPaymentIncidents = (
  session: Session,
  signal?: AbortSignal,
): Promise<PaymentIncidentListResponse> =>
  apiFetch('/api/v1/admin/payment-incidents', {
    session,
    schema: PaymentIncidentListResponseSchema,
    ...(signal ? { signal } : {}),
  });

export type IncidentAction = 'fulfil' | 'refund';

export const actOnIncident = (
  session: Session,
  incidentId: string,
  action: IncidentAction,
): Promise<PaymentIncidentActionResponse> =>
  apiFetch(`/api/v1/admin/payment-incidents/${incidentId}/${action}`, {
    session,
    method: 'POST',
    schema: PaymentIncidentActionResponseSchema,
  });

export const resolveIncident = (
  session: Session,
  incidentId: string,
  note: string,
): Promise<PaymentIncidentActionResponse> =>
  apiFetch(`/api/v1/admin/payment-incidents/${incidentId}/resolve`, {
    session,
    method: 'POST',
    body: { note },
    schema: PaymentIncidentActionResponseSchema,
  });
